"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditMode = exports.LayoutServicePageState = void 0;
/**
 * Layout Service page state enum
 */
var LayoutServicePageState;
(function (LayoutServicePageState) {
    LayoutServicePageState["Preview"] = "preview";
    LayoutServicePageState["Edit"] = "edit";
    LayoutServicePageState["Normal"] = "normal";
})(LayoutServicePageState || (exports.LayoutServicePageState = LayoutServicePageState = {}));
/**
 * Represents the possible modes for rendering content in Sitecore Editor
 * - chromes - supported by Sitecore Experience Editor / Pages
 * - metadata - supported by Sitecore Pages
 */
var EditMode;
(function (EditMode) {
    EditMode["Chromes"] = "chromes";
    EditMode["Metadata"] = "metadata";
})(EditMode || (exports.EditMode = EditMode = {}));
